<template>
  <div class="select-user-component" :class="appendClass">
    <a-select
        show-search
        option-filter-prop="children"
        style="display: block;"
        :placeholder="placeholder"
        :mode="mode"
        :disabled="disabled"
        :value="internalValue"
        :filter-option="filterOption"
        @focus="handleFocus"
        @blur="handleBlur"
        @change="handleChange"
        :allow-clear="allowClear"
    >
      <template v-if="customOptions.length">
        <a-select-option v-for="option in customOptions" v-bind:key="option.id" v-bind:value="option.id">
          {{ label(option) }}
        </a-select-option>
      </template>

      <template v-else>
        <a-select-option v-for="user in users" v-bind:key="user.id" v-bind:value="user.id">
          {{ label(user) }}
        </a-select-option>
      </template>
    </a-select>
    <input v-if="multiple" type="hidden" :name="fieldName" v-for="user in internalValue" :value="user"/>
    <input v-else type="hidden" :name="fieldName" :value="internalValue"/>
  </div>
</template>

<script>
import store from '../store'
import BadgeComponent from './BadgeComponent'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SelectUsersComponent',
  props: {
    fieldName: {
      type: String,
      default: ''
    },
    value: {
      type: [Array, Number, String],
      default: () => ([])
    },
    appendClass: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    allowClear: {
      type: Boolean,
      default: false,
    },
    customOptions: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },
  components: {
    BadgeComponent
  },
  data () {
    return {
      internalValue: null,
      page: 1,
      pages: 0,
      perPage: 15,
      data: [],
      searchResults: [],
      selectedValues: [],
      fetching: false
    }
  },
  computed: {
    ...mapGetters('$_user', [
      'users',
      'hasUsers',
    ]),
    mode () {
      return this.multiple ? 'multiple' : null
    },
    placeholder () {
      return this.multiple ? 'Selecteer gebruikers' : 'Selecteer een gebruiker'
    },
  },
  methods: {
    ...mapActions('$_user', [
        'fetchUsers',
    ]),
    handleChange (values) {
      this.internalValue = values
      this.$emit('change', values)
      this.$emit('input', values)
    },
    handleBlur () {
      this.$emit('blur')
    },
    handleFocus () {
      this.$emit('focus')
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    label (user) {
      if (user.first_name === null && user.last_name === null) {
        return `Geen naam ${user.username ? `(${user.username})` : ''}`
      }

      return `${user.first_name ? user.first_name : ''} ${user.last_name ? user.last_name : ''}`
    }
  },
  created () {
    const STORE_KEY = '$_user'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }

    this.fetchUsers()

    this.internalValue = this.value
  },
  watch: {
    value () {
      this.internalValue = this.value
    }
  }
}
</script>

<style scoped>
.ant-select-selection__choice__remove {
    margin-top: .5rem;
}

.d-center {
    display: flex;
    align-items: center;
}

.selected .ant-avatar {
    height: 25px;
    width: 25px;
}

.small >>> .selected .ant-avatar {
    height: 14px;
    width: 14px;
}

.selected .user-badge {
    padding: 1rem 0.5rem;
}

.v-select .dropdown li {
    border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.v-select .dropdown li:last-child {
    border-bottom: none;
}

.v-select .dropdown li a {
    padding: 10px 20px;
    width: 100%;
    font-size: 1.25em;
    color: #3c3c3c;
}

.v-select .dropdown-menu .active > a {
    color: #fff;
}

.v-select-loader {
    text-align: center;
    color: #bbbbbb;
}

</style>
